import React, { useState } from "react";
import { uniqueId } from "../../utils/generalLiveCenter";


export default function RugbyLineupBox({ home, away, title }) {
  const [show, setShow] = useState(true);
  const handleClick = () => {
    setShow(!show);
  };
  return (
    <div className="lineup_box">
      <span className="lineup_box_opener" onClick={handleClick}>
        {title}
      </span>
      {show && (
        <div className="lineup_columns">
          <ul className="list_lineup">
            {home?.map((player, i) => (
              <li key={uniqueId(player?.sno) + i}>
                <span className="lineup_num">{player?.sno}</span>
                <span className="lin_name">
                  {title === "Substitute" ? player?.pin_nm : player?.player?.nm}
                </span>
              </li>
            ))}
          </ul>
          <ul className="list_lineup reverse">
            {away?.map((player, i) => (
              <li key={uniqueId(player?.sno) + i}>
                <span className="lineup_num">{player?.sno}</span>
                <span className="lin_name">
                  {title === "Substitute" ? player?.pin_nm : player?.player?.nm}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
